import {
    CircleMarker,
    MapContainer,
    TileLayer,
    useMap,
} from "react-leaflet";

import "leaflet/dist/leaflet.css";
import { useEffect } from "react";
import { Box } from "@mui/material";

import { PRIMARY_COLOR } from "../util/constants";

function UpdatePosition({ latitude, longitude, zoom }) {
    const map = useMap();

    useEffect(() => {
        map.setView([latitude, longitude], zoom);
    }, [map, latitude, longitude, zoom]);

    return null;
}

export default function StaticMap({
    latitude,
    longitude,
    zoom = 14,
    height = 300,
}) {
    const position = [latitude, longitude];

    return (
        <Box
            sx={{
                width: "100%",
                height,
                overflow: "hidden",
                borderRadius: 2,
                pointerEvents: "none",
            }}
        >
            <MapContainer
                center={position}
                zoom={zoom}
                zoomControl={false}
                dragging={false}
                scrollWheelZoom={false}
                doubleClickZoom={false}
                boxZoom={false}
                keyboard={false}
                touchZoom={false}
                attributionControl
                style={{
                    width: "100%",
                    height: "100%",
                }}
            >
                <TileLayer
                    url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="&copy; OpenStreetMap contributors"
                />
                {
                    latitude !== null && longitude !== null ?
                        <CircleMarker
                            center={position}
                            radius={8}
                            pathOptions={{
                                color: PRIMARY_COLOR,
                                fillColor: null,
                                fillOpacity: 1,
                            }}
                        />
                        :
                        null
                }


                <UpdatePosition
                    latitude={latitude}
                    longitude={longitude}
                    zoom={zoom}
                />
            </MapContainer>
        </Box>
    );
}